import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class SmartFeedColumnMaxWidth extends BaseOption {
  static label = "Column Max Width";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      append: "px",
      defaultEmptyValue: 350,
    },
  };

  static defaultValue = 350;

  static canShow(smartFeedType) {
    return smartFeedType === "grid";
  }
}
